export enum CenterAddressType {    
    Primary = 1,
    CenterBilling = 2,
    NkrBilling = 3,
    LabCenter = 4,
    GpsShipTo = 6,
    KidneyPickup = 7,
    KidneyShipTo = 8,
    ExchangeCoordinator = 9,
    XmShipTo = 10,
    StrongBoxShipTo = 11
}